import { types } from 'mobx-state-tree';

export const EntrepreneurBlockModel = types
  .model('EntrepreneurBlockModel', {
    entrepreneurName: types.maybe(types.string),
    entrepreneurAddress: types.maybe(types.string),
    entrepreneurPostalCode: types.maybe(types.string),
    entrepreneurPostalCity: types.maybe(types.string),
    entrepreneurOrganisationNumber: types.maybe(types.string),
    supervisorName: types.maybe(types.string),
    supervisorPhoneNumber: types.maybe(types.string),
    supervisorMobilePhoneNumber: types.maybe(types.string),
    supervisorEmail: types.maybe(types.string)
  })
  .volatile(() => ({
    useSameAsApplicantForEntrepreneur: false
  }))
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
